export interface UserDataDto {
  name: string;
  email: string;
  username: string;
  address: string;
  profile_picture: Blob;
}
